import { theme } from "antd";

export const antdTheme = {
  token: {
    // algorithm: theme.darkAlgorithm,

  },

  components: {


    Checkbox: {
      // colorPrimary: "var(--color-brand)",
      // colorText: "var(--color-text-footer)",
    },

    "Modal": {
      "headerBg": "transparent",
      "contentBg": "var(--color-bg-modal)"
    },

    DatePicker: {
      "colorBgContainer": "var(--color-bg-select)",
      "colorBorder": "var(--color-border-select)",
      "colorText": "var(--color-main-text)",
      "colorIcon": "var(--color-main-text)",

      "colorBgElevated": "var(--color-bg-drawer)",
      colorTextHeading: "var(--color-main-text)",
      colorTextQuaternary: "var(--color-main-text)",
      colorTextPlaceholder: "var(--color-text-des)"

    },

    Select: {
      colorPrimary: "var(--color-brand)",
      colorText: "var(--color-main-text)",
      colorBgContainer: "transparent",
      optionSelectedBg: "var(--color-bg-button-icon-active)",
      colorTextPlaceholder: "var(--color-text-des)",
      colorBgElevated: "var(--color-bg-select)",
      "colorBorder": "var(--color-border-select)",
      "multipleItemBg": "var(--neutral-950)",
      "multipleItemHeight": 28,
      "multipleItemColorDisabled": "var(--text-primary)"
    },
    Input: {
      colorBgContainer: "var(--color-bg-select)",
      colorText: "var(--color-text-select)",
      colorTextPlaceholder: "var(--color-text-des)",
    },
    InputNumber: {
      colorBgContainer: "var(--color-bg-select)",
      colorText: "var(--color-text-select)",
      colorTextPlaceholder: "var(--color-text-des)",
    },
    Radio: {
      colorPrimary: "var(--color-radio)",
      colorText: "var(--color-text-footer)",
    },
    // "Steps": {
    //   colorPrimary: "var(--color-primary-steps)",
    //   colorPrimaryBg: "var(--color-secondary-brand)",
    //   colorText: "var(--color-text-select)",
    // },

    "Divider": {
      "colorSplit": "var(--color-divider-content)"
    },
    "Tabs": {
      "itemSelectedColor": "var(--color-bg-btn-nav-primary)",
      "colorText": "var(--color-text-select)",
      "inkBarColor": "var(--color-bg-btn-nav-primary)",
      "fontSizeIcon": 14
    },
    "Collapse": {
      "headerBg": "var(--color-bg-select)",
      "colorText": "var(--color-main-text)",
      "colorTextHeading": "var(--color-main-text)"
    },

    "Dropdown": {
      "colorBgElevated": "var(--color-bg-select)",
      "colorText": "var(--color-main-text)",
      "controlItemBgHover": "var(--neutral-700)"
    },
    "Popover": {
      "colorBgElevated": "var(--neutral-950)",
      "colorText": "var(--color-main-text)",
      "colorTextHeading": "var(--color-main-text)",
    },
    "Table": {
      "headerBg": "var(--neutral-800)",
      "headerColor": "var(--text-secondary)",
      "colorBgContainer": "var(--neutral-950)",
      "colorText": "var(--text-primary)",
      "borderColor": "var(--divider-2)",
      "rowHoverBg": "var(--neutral-800)",
      "footerBg": "var(--neutral-800)",
      "footerColor": "var(--text-secondary)",
    }

  },
};
